<template>
<div class="company-info">
	<div class="banner" :style="`background-image: url(${shopInfo.shopBanner || defaultBanner})`"></div>
	<div class="bannerMiddle">
		<div class="w bannerMiddleBox">
			<el-image style="width: 120px; height: 120px; margin-right: 50px;border-radius: 50%;"
				:src="shopInfo.shopLogo || defaultLogo" fit="cover"></el-image>
			<div class="bannerMiddleBox_info">
				<div class="bannerMiddleBox_Title 0f-1">{{ shopInfo.shopName }}</div>
				<el-divider></el-divider>
				<div class="bannerMiddleBox_main of-4">{{ shopInfo.shopIntroduce || '--' }}</div>
			</div>
		</div>
	</div>
	<div class="company-info-tab">
		<el-menu :default-active="activeName" class="w" mode="horizontal" @select="tabClick"
			active-text-color="#409eff">
			<el-menu-item index="1">店铺介绍</el-menu-item>
			<el-menu-item index="2">全部商品</el-menu-item>
		</el-menu>
	</div>
	<div v-if="activeName == 1 && shopInfo.id">
		<CompanyBasicIntro :companyData="shopInfo" :supplierData="supplierInfo" v-if="!shopInfo.decoration"/>
		<CompanyAdvancedIntro :shopData="shopInfo" v-else/>
	</div>
	<div v-if="activeName == 2" class="w">
		<companyProductList :shopId="shopInfo.id"></companyProductList>
	</div>
</div>
</template>

<script>
import defaultBanner from '../../assets/imgs/RemoteSensingMall/companyInfoBanner.png'
import defaultLogo from '../../assets/imgs/logo.png'
import CompanyBasicIntro from "../../components/RemoteSensingMall/CompanyBasicIntro.vue";
import CompanyAdvancedIntro from "../../components/RemoteSensingMall/CompanyAdvancedIntro.vue";
import companyProductList from "@/components/RemoteSensingMall/companyProductList.vue";

export default {
	components: {
		companyProductList, CompanyBasicIntro, CompanyAdvancedIntro, CompanyBasicIntro
	},
	data() {
		return {
			defaultBanner, defaultLogo,
			activeName: "1",
			// 商品id
			goodsId: '',
			supplierInfo: {},
			shopInfo: {}
		};
	},
	created() {
		if (this.$route.query.goodsId) {
			// 当传入值为商品id时
			this.goodsId = this.$route.query.goodsId;
			this.getSupplierInfoFn()
		} else if (this.$route.query.shopId && this.$route.query.supplierId) {
			// 当传入值为店铺id和商家id时
			this.getSupplierInfoFn2()
		} else {
			this.$message.warning('商家信息不存在，即将返回首页');
			var that = this;
			setTimeout(function () {
				that.$router.push('/');
			}, 2000)
		}
	},
	methods: {
		async getSupplierInfoFn2() {
			// shopId进入
			try {
				let res = await this.$http.get(this.$const.RemoteSensingMall.IDsolutionSupplierGet + this.$route.query.supplierId);
				if (res && res.data && res.code === 200) {
					this.supplierInfo = res.data;
					console.log(this.supplierInfo)
				}
				let res1 = await this.$http.post(this.$const.RemoteSensingMall.IDsolutionshopGet, {
					shopId: this.$route.query.shopId,
					userId: this.$store.state.user.userInfo.id
				});
				if (res1.data && res1.code === 200) {
					this.shopInfo = res1.data;
					console.log(this.shopInfo)
				}
			} catch (e) {
				// console.log(e);
			}
		},
		async getSupplierInfoFn() {
			try {
				let res = await this.$http.get(this.$const.RemoteSensingMall.IDsupplierGet + this.goodsId);
				if (res && res.data && res.code === 200) {
					// console.log(res);
					this.supplierInfo = res.data;
				}
				let res1 = await this.$http.post(this.$const.RemoteSensingMall.IDshopGet, {
					goodsId: this.goodsId,
					userId: this.$store.state.user.userInfo.id
				});
				if (res1 && res1.data && res1.code === 200) {
					// console.log('----',res1);
					this.shopInfo = res1.data;
				}
			} catch (e) {
				// console.log(e);
			}
		},
		tabClick(e) {
			this.activeName = e;
		},
	},
};
</script>

<style lang="scss" scoped>
.company-info {
	background-color: #F5F5F5;

	> .banner {
		position: relative;
		width: 100%;
		height: 430px;
		margin: 0;
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
	}

	> .bannerMiddle {
		position: relative;
		width: 100%;
		margin: 0;
		height: 245px;
		background-image: url("../../assets/imgs/RemoteSensingMall/companyInfoMiddle.png");
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
		
		> .bannerMiddleBox {
			display: flex;
			align-items: center;
			padding: 50px 0;

			> .bannerMiddleBox_info {
				flex: 1;
				height: 130px;

				> .el-divider {
					width: 50px;
					height: 2px;
					margin: 20px 0;
					background-color: #2569F2;
				}
				> .bannerMiddleBox_Title {
					height: 40px;
					line-height: 40px;
					font-size: 24px;
					font-weight: bold;
					margin-bottom: 10px;
				}
				> .bannerMiddleBox_main {
					height: 80px;
					line-height: 20px;
					font-size: 16px;
				}
			}
		}
	}
	> .company-info-tab {
		margin: 30px 0;
		background-image: linear-gradient(180deg, #FFFFFF 0%, #F5F5F5 100%);

		> ::v-deep .el-menu {
			margin: 0 auto;
			background-color: transparent;

			> li {
				position: relative;
				padding-left: 36px;
				padding-right: 36px;
				color: #666666;
				font-size: 20px;
				font-weight: 700;
				border-bottom: none !important;

				&.is-active, &:hover {
					background-image: linear-gradient(180deg, #E0EAFF 0%, #F5F5F5 100%);
					border-bottom: none !important;
					color: black !important;

					&::before {
						content: '';
						position: absolute;
						top: 6px;
						left: 6px;
						border: 6px solid transparent;
						border-top-color: #2569F2;
						border-left-color: #2569F2;
					}
				}
			}
		}
	}	
}

/* 顶栏容器CSS END */
.el-menu.el-menu--horizontal {
	border-bottom: 0px;
}

.el-menu--horizontal>.el-menu-item {
	font-size: 22px;
	color: #333;
}

.el-menu--horizontal>.el-menu-item.is-active {
	border-bottom: 3px solid #2469f1 !important;
	font-weight: 700;
	color: #2469f1 !important;
}

.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
	color: #2469f1 !important;
	border-bottom: 3px solid #2469f1 !important;
	font-weight: 700;
}
</style>